import { render, staticRenderFns } from "./AppAgree.vue?vue&type=template&id=f2be7d5e&scoped=true&"
import script from "./AppAgree.vue?vue&type=script&lang=ts&"
export * from "./AppAgree.vue?vue&type=script&lang=ts&"
import style0 from "./AppAgree.vue?vue&type=style&index=0&id=f2be7d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2be7d5e",
  null
  
)

export default component.exports